import Yggdrasil from 'services/yggdrasil'

const state = {
    notes: []
}

const mutations = {
    ASSIGN_NOTES (state, note) {
        state.notes = note
    },
    CREATE_NOTE (state, note) {
        state.notes.push(note)
    },
    UPDATE_NOTE (state, modifiedNote) {
        const newNote = Array.isArray(modifiedNote) ? modifiedNote[0] : modifiedNote

        const existingNote = state.notes.find(note => +note.id === +newNote.id)
        if (existingNote && existingNote.content === newNote.content) {
            return
        }

        state.notes = state.notes.filter(note => +note.id !== +newNote.id)
        state.notes.push(newNote)
    },
    REMOVE_NOTE (state, id) {
        state.notes = state.notes.filter(note => +note.id !== +id)
    },
    CLEAR_AFTER_LOGOUT (state) {
        state.notes = []
    }
}

const actions = {
    async clearAfterLogout (store) {
        store.commit('CLEAR_AFTER_LOGOUT')
    },
    async loadNotes (store) {
        const notes = await Yggdrasil.loadNotes()
        store.commit('ASSIGN_NOTES', notes)
    },
    async UpsertNote (store, { courseId, content }) {
        const addedNote = await Yggdrasil.UpsertNote(courseId, content)
        store.commit('UPDATE_NOTE', addedNote)
    },
    async updateNote (store, { id, content }) {
        const modifiedNote = await Yggdrasil.updateNote(id, content)
        store.commit('UPDATE_NOTE', modifiedNote)
    },
    async deleteNote (store, id) {
        await Yggdrasil.deleteNote(id)
        store.commit('REMOVE_NOTE', id)
    }
}

const getters = {
    getNotes: (state) => state.notes,
    getNoteForCourse: (state) => (courseId) => state.notes.find(note => +note.courseId === +courseId)
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
